import { SHOW_G5_DEVICES_MODAL, HIDE_G5_DEVICES_MODAL } from '../constants/ActionTypes';

export const showG5DevicesModal = () => ({
  type: SHOW_G5_DEVICES_MODAL,
});

export const hideG5DevicesModal = () => ({
  type: HIDE_G5_DEVICES_MODAL,
}); 